/** One destination in the owner top bar. `match` lists the path prefixes that light it up. */
export interface NavItem {
  label: string;
  path: string;
  match: readonly string[];
}

/** The owner top bar, in the prototype's order. */
export const NAV: readonly NavItem[] = [
  // Why: a goal's own pages belong to the Command Center, as in the prototype.
  { label: "Command Center", path: "/command", match: ["/command", "/goals"] },
  // Why: a product's partners, pay run and agreement live under /products, so they keep Products lit.
  { label: "Products", path: "/products", match: ["/products"] },
  { label: "Library", path: "/library", match: ["/library"] },
  { label: "Connections", path: "/connections", match: ["/connections"] },
];

export const isNavActive = (item: NavItem, path: string): boolean =>
  item.match.some((prefix) => path.startsWith(prefix));
